export default __webpack_public_path__ + "static/media/docIcon.317dc8ca.png";